import { BaseDto } from "@/shared/dtos/base-dto";

export class pacientes_leads extends BaseDto {
  public nombre: string = "";
  public apellidos: string = "";
  public telefono: string = "";
  public email: string = "";
  public fecha_nacimiento: Date | null = null;
  public documento: string = "";
  public observaciones: string = "";
  public created_at: Date | null = null;
  public updated_at: Date | null = null;

  constructor(data?: any) {
    super();
    if (!data) return;
    this.copy(data);
    if (data.fecha_nacimiento) this.fecha_nacimiento = new Date(data.fecha_nacimiento);
    if (data.created_at) this.created_at = new Date(data.created_at);
    if (data.updated_at) this.updated_at = new Date(data.updated_at);
  }
}
